import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { AiAgentSelect } from "@/react/components/shared/uikit/AiAgentSelect";
import { Form } from "@circle-react-uikit/Form";
import { useCurrentAction } from "../../../ActionRule";
import { useDefaultValueForField } from "../../../useDefaultValueforField";

export const FormHidePostFromFeaturedAreas = () => {
  const { paramsPath } = useCurrentAction();

  const { setValue, getValues } = useFormContext();

  const selectedId = getValues(`${paramsPath}.community_bot_profile_id`) as
    | number
    | null;

  useDefaultValueForField(`${paramsPath}.community_bot_profile_id`, null);

  return (
    <div className="flex flex-col gap-9">
      <Form.Item
        name={`${paramsPath}.community_bot_profile_id`}
        hideBorder
        fullWidth
        hideDescription
        label={t("settings.workflows.form.agent")}
        labelClassName="!mb-2 !text-sm"
        className="!py-0"
      >
        <AiAgentSelect
          selectedId={selectedId}
          setValue={(value: number) =>
            setValue(`${paramsPath}.community_bot_profile_id`, value)
          }
          placeholderKey="settings.workflows.form.select_agent"
          notFoundKey="settings.workflows.form.no_agents_found"
          enabledStatus
        />
      </Form.Item>
    </div>
  );
};
